"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
export class AccountSeurityEditDeviceForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.device_name = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "accountseurityeditdevicedialog.device_name_cannot_be_empty"
      ),
      trigger: "blur"
    }
  ])
], AccountSeurityEditDeviceForm.prototype, "device_name", 2);
let AccountSeurityEditDeviceDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.row = {};
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.controller = new AccountSeurityEditDeviceForm();
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        const response = yield API.put(
          `api://base.auth/api/v7/accounts/edit/device/${this.row.guid}`,
          {
            device_name: this.controller.device_name
          }
        );
        this.$message.success(
          this.$t(
            "accountseurityeditdevicedialog.modified_successfully"
          )
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  open(row) {
    this.row = row;
    this.controller = new AccountSeurityEditDeviceForm();
    this.controller.device_name = row.device_name;
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
};
AccountSeurityEditDeviceDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], AccountSeurityEditDeviceDialog);
export {
  AccountSeurityEditDeviceDialog as default
};
